










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class EmptyState extends Vue {
  @Prop({ default: 'frown' })
  private readonly icon!: string;

  @Prop({ required: true })
  private readonly title!: string;

  @Prop()
  private readonly btnText!: string;
}
